/*
 * FJX 28-OCT-2026 · Colores en la tarjeta de producto (Opción B)
 * --------------------------------------------------------------
 * Tocar un color cambia la foto de la tarjeta a ese color, sin salir de la página.
 * - Celular: tocar = elegir el color.
 * - Computador: pasar el mouse = vista previa; al salir vuelve al color elegido; clic = elegir.
 * - Al elegir, la foto y el nombre llevan a la ficha con ESE color seleccionado.
 * - Con un color elegido se apaga el carrusel de fotos al pasar el mouse por la imagen
 *   (si no, mostraría fotos de otros colores).
 * - Las fotos de cada color se descargan recién cuando la clienta se acerca a la tarjeta
 *   (antes el tema descargaba todas al cargar la página).
 * La foto de cada color la calcula snippets/product-card-swatch.liquid (data-fjx-srcset).
 * Escucha en fase de captura para reemplazar el comportamiento original del tema
 * (app.js · ProductCard.enableSwatches), que llevaba a la ficha al tocar un color.
 * Funciona también con tarjetas que llegan después (scroll infinito, pestañas, filtros).
 */
(function () {
  if (window.__fjxCardSwatch) return;
  window.__fjxCardSwatch = true;

  var SW = '.product-card-swatch';
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  var css = document.createElement('style');
  css.textContent =
    'product-card.fjx-color-picked .product-secondary-image,' +
    'product-card.fjx-color-picked .product-secondary-images-nav{display:none!important}' +
    'product-card .product-card-swatch:focus-visible{outline:2px solid #151515;outline-offset:2px}';
  document.head.appendChild(css);

  function getSwatch(target) {
    var sw = target && target.closest ? target.closest(SW) : null;
    return sw && sw.closest('product-card') ? sw : null;
  }

  function parts(el) {
    var card = el.closest('product-card');
    if (!card) return null;
    var img = card.querySelector('.product-card--featured-image-link .product-primary-image');
    if (!card._fjx) {
      var links = card.querySelectorAll('a.product-card--featured-image-link, a.product-card-title');
      card._fjx = {
        org: img ? (img.getAttribute('data-srcset') || img.getAttribute('srcset') || '') : '',
        href: links.length ? links[0].getAttribute('href') : '',
        init: card.querySelector(SW + '.active'),
        sel: null,
        warm: false,
        links: links
      };
    }
    return { card: card, img: img, list: card.querySelectorAll(SW), s: card._fjx };
  }

  function setSrc(img, srcset) {
    if (!img || !srcset) return;
    if (img.getAttribute('data-srcset') === srcset && img.getAttribute('srcset') === srcset) return;
    img.setAttribute('data-srcset', srcset);
    // Si lazysizes ya cargó la foto, se cambia ya; si no, la cargará con el color nuevo.
    if (img.hasAttribute('srcset')) img.setAttribute('srcset', srcset);
  }

  function show(p, sw) {
    var srcset = sw && sw.dataset.fjxSrcset ? sw.dataset.fjxSrcset : p.s.org;
    setSrc(p.img, srcset);
  }

  function mark(p, sw) {
    p.list.forEach(function (el) {
      var on = el === sw;
      el.classList.toggle('active', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function warm(p) {
    if (p.s.warm || !p.img) return;
    p.s.warm = true;
    var sizes = p.img.getAttribute('sizes');
    if (!sizes || sizes === 'auto') sizes = (p.img.offsetWidth || 300) + 'px';
    p.list.forEach(function (sw) {
      if (!sw.dataset.fjxSrcset) return;
      var pre = new Image();
      pre.decoding = 'async';
      pre.sizes = sizes;
      pre.srcset = sw.dataset.fjxSrcset;
    });
  }

  function select(sw) {
    var p = parts(sw);
    if (!p) return;
    p.s.sel = sw;
    show(p, sw);
    mark(p, sw);
    p.card.classList.add('fjx-color-picked');
    var href = sw.dataset.href || p.s.href;
    if (href) p.s.links.forEach(function (a) { a.setAttribute('href', href); });
  }

  // Elegir color (toque o clic)
  document.addEventListener('click', function (e) {
    var sw = getSwatch(e.target);
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    select(sw);
  }, true);

  // Teclado: Enter o espacio
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var sw = getSwatch(e.target);
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    select(sw);
  }, true);

  // Vista previa al pasar el mouse (solo computador)
  document.addEventListener('mouseover', function (e) {
    var sw = getSwatch(e.target);
    if (!sw) return;
    e.stopPropagation(); // evita el cambio original del tema
    if (!canHover) return;
    var p = parts(sw);
    warm(p);
    show(p, sw);
    mark(p, sw);
  }, true);

  // Al salir de los colores, vuelve al color elegido (o al original)
  document.addEventListener('mouseout', function (e) {
    if (!canHover) return;
    var sw = getSwatch(e.target);
    if (!sw) return;
    var box = sw.parentElement;
    if (e.relatedTarget && box.contains(e.relatedTarget)) return;
    var p = parts(sw);
    show(p, p.s.sel);
    mark(p, p.s.sel || p.s.init);
  }, true);

  // Precarga las fotos de los colores cuando la clienta se acerca a la tarjeta
  function warmFrom(e) {
    var card = e.target && e.target.closest ? e.target.closest('product-card') : null;
    if (!card || !card.querySelector(SW)) return;
    warm(parts(card));
  }
  document.addEventListener('pointerover', warmFrom, { capture: true, passive: true });
  document.addEventListener('focusin', warmFrom, true);
})();
